import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var config = {
  apiKey: "AIzaSyA6L7lkt1THpsBlB8_PjFHmX3xvA58__AM",
  authDomain: "syncparty-35cd8.firebaseapp.com",
  databaseURL: "https://syncparty-35cd8.firebaseio.com",
  projectId: "syncparty-35cd8",
  storageBucket: "syncparty-35cd8.appspot.com",
  messagingSenderId: "436813956357"
};
firebase.initializeApp(config);

const storage = firebase.storage();
const db = firebase.firestore();
export {
  db, storage, firebase as default
}